// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapImage } from '../../../dsl/front'

import { Site } from '../../_contracts'

import { LineHeaderTheme } from './LineHeader.contracts'
import { siteLogoClassNameRegistry } from './LineHeader.config'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'LineHeader',
  components: { BootstrapImage },
  template: `
    <header class="line-header" :class="themeClass">
      <component :is="tag" class="line-header__content" :class="[fontWeightClass, pointerClass, siteImgClass]">
        <i v-if="siteImgClass" class="line-header__content__site-logo" />

        <slot />
      </component>

      <slot name="nav" />
    </header>
  `
})
export class LineHeader extends Vue {
  /**
   * Determines whether the main content should be bold.
   */
  @Prop({ type: Boolean, required: false, default: false })
  private readonly isBold!: boolean

  /**
   * Determines whether the red pointer should be rendered
   * on the left side of the main content.
   */
  @Prop({ type: Boolean, required: false, default: false })
  public readonly showPointer!: boolean

  /**
   * Site identifier. If specified, will be used to inject correct logotype.
   */
  @Prop({ type: String, required: false })
  private readonly site?: Site

  /**
   * The HTML tag that is to be used as a root element for the main content.
   */
  @Prop({ type: String, required: false, default: 'h2' })
  public readonly tag!: string

  /**
   * The theme (color scheme) of the component.
   */
  @Prop({ type: String, required: false, default: LineHeaderTheme.Light })
  private readonly theme!: LineHeaderTheme

  /**
   * The CSS class that sets the `font-weight` of the main content.
   */
  public get fontWeightClass (): string {
    return ''
    // return this.isBold ? 'fw-bold' : 'fw-normal'
  }

  /**
   * The CSS class that controls the `--with-pointer` modifier class.
   */
  public get pointerClass (): string|null {
    return this.showPointer && this.siteImgClass ? '--with-pointer' : null
  }

  /**
   * Full path to the site's logotype.
   */
  public get siteImgClass (): string|undefined {
    if (typeof this.site === 'undefined') {
      return
    }

    const className = siteLogoClassNameRegistry[this.site]

    if (typeof className !== 'string' || className.length === 0) {
      return
    }

    return `--${this.theme}-${className}`
  }

  /**
   * The CSS class that sets the color scheme (light/dark) of the component.
   */
  public get themeClass (): string {
    return `--${this.theme}`
  }
}
